export const environment = {
  production: true,
  test_front: false,
};
